import { interfaces } from 'inversify';
import { useMemo } from 'react';

import IocContainer from '../../../shared/src/Core/IocContainer';

export function useService<T>(serviceIdentifier: interfaces.ServiceIdentifier<T>) {
    const service = useMemo(() => IocContainer.get<T>(serviceIdentifier), [serviceIdentifier]);
    return service;
}
